import type { SVGProps } from 'react';
const directionalChevrondownTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M19.6923 6.99199C19.9722 6.68665 20.4466 6.66602 20.752 6.94592C21.0573 7.22581 21.0779 7.70024 20.798 8.00558L12.548 17.0056C12.2508 17.3299 11.7396 17.3299 11.4423 17.0056L3.19232 8.00558C2.91242 7.70024 2.93305 7.22581 3.23839 6.94592C3.54373 6.66602 4.01815 6.68665 4.29805 6.99199L11.9952 15.388L19.6923 6.99199Z"
      fill={props.color ?? '#000'}
      fillRule="evenodd"
    />
  </svg>
);
export default directionalChevrondownTemplateOutline;
